

import React, { useContext } from 'react'
import { SkyInformationPopover } from './SkyPopover';
import { FirebaseService, FirebaseConfigKey } from '../../../services/FirebaseService';
import { InsurancePurchaseContextStore, INSURANCE_CONTEXT_ACTIONS } from '../../../context/InsuracePurchaseContext'
import { PolicyHullExtensionContextStore, ACTIONS } from '../../../context/PolicyHullExtensionContext';
import { useLocation, useParams } from 'react-router-dom';
import { InsuranceBillingPeriod } from '../../../models/insurance-models/InsuranceBillingPeriodModel';
import { isCanada } from '../../../services/utils';
var classNames = require('classnames')

export const HullPopover = (props) => {
  const location = useLocation()
  const insurancePurchaseContext = useContext(InsurancePurchaseContextStore)
  
  return (
      <SkyInformationPopover eventId={'hull'}>
            <div className="text-body bold">Hull coverage protects damage sustained to the drone and equipment in flight and on ground</div>
            <div className="text-small margin-top-small">- Includes flyaway, theft, disappearance</div>
            <div className="text-small margin-top-small">- Covers drones up to 35 pounds. For heavier drones, please contact us</div>
            {
              insurancePurchaseContext.selectedOption == InsuranceBillingPeriod.MONTH && !FirebaseService.getBoolean(FirebaseConfigKey.HULL_INSURANCE_AVAILABLE_FOR_MONTHLY)?
            <div className="text-small margin-top-small">
              - Deductibles are {(FirebaseService.getValue(insurancePurchaseContext.selectedOption.billingPeriod == InsuranceBillingPeriod.MONTH? FirebaseConfigKey.HULL_ESTIMATED_DEDUCTIBLE_FACTOR : FirebaseConfigKey.HULL_ESTIMATED_DEDUCTIBLE_FACTOR_ANNUAL) * 100).toFixed(0)}% of the drone(s) 
              insured value while the premiums 
              are {(FirebaseService.getValue(insurancePurchaseContext.selectedOption.billingPeriod == InsuranceBillingPeriod.MONTH? FirebaseConfigKey.HULL_ESTIMATED_PREMIUM_FACTOR : FirebaseConfigKey.HULL_ESTIMATED_PREMIUM_FACTOR_ANNUAL) * 100).toFixed(2)}%</div> 
              : 
            <div className={`text-small margin-top-small`}>- Hull insurance is available through our annual {isCanada ? '' :'and monthly'} plan</div>
            }
        </SkyInformationPopover>
  );
}